import PasswordGate from './components/PasswordGate';
import PasswordProtectionManager from './components/PasswordProtectionManager';
import MoreMenuLink from './components/MoreMenuLink';

const applyConfig = (config) => {
  // Overrides Volto's default 401 error view. PasswordGate itself checks
  // whether this 401 is actually our own collective.folderprotection.volto
  // response and falls back to Volto's normal Unauthorized view otherwise -
  // so this doesn't change behavior for ordinary "please log in" 401s.
  config.views.errorViews['401'] = PasswordGate;

  // Editor-facing management panel, reachable from the object's "More"
  // menu - same route pattern Volto's own /sharing uses (site root and any
  // nested object).
  config.addonRoutes = [
    ...(config.addonRoutes || []),
    {
      path: ['/password-protection', '/**/password-protection'],
      component: PasswordProtectionManager,
    },
  ];

  // Without this, getBaseUrl() doesn't know /password-protection is a view
  // suffix rather than part of the content path - harmless when navigating
  // there from a normal content page, but while already on the panel it
  // makes MoreMenuLink append a second /password-protection instead of
  // reproducing the same URL, which 404s. Same mechanism Volto's own
  // /sharing relies on (see NonContentRoutes.jsx).
  config.settings.nonContentRoutes = [
    ...(config.settings.nonContentRoutes || []),
    '/password-protection',
  ];

  // Renders the "More" menu link on every page (see MoreMenuLink.jsx for
  // why this needs appExtras rather than a direct Plug).
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: { path: '/**', exact: false },
      component: MoreMenuLink,
    },
  ];

  return config;
};

export default applyConfig;
